import { useEffect } from "react";
import { FAQS } from "@/lib/business";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  useEffect(() => {
    // Inject FAQ JSON-LD for SEO
    const data = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.flatMap(g => g.items).map(item => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(data);
    script.setAttribute("data-faq-schema", "true");
    document.head.appendChild(script);
    return () => {
      const existing = document.querySelector('script[data-faq-schema="true"]');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div>
      <section className="hero-wash">
        <div className="container-x py-12">
          <p className="text-sm font-semibold text-[color:var(--icrack-magenta-deep)] uppercase tracking-wider">Help Centre</p>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold">Frequently asked questions</h1>
          <p className="mt-3 max-w-2xl text-slate-600">Everything you need to know about our repair services, pricing, warranty, and mobile call-out visits.</p>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-x max-w-3xl space-y-10">
          {FAQS.map((g, gi) => (
            <div key={g.group} data-testid={`faq-group-${g.group.toLowerCase().replace(/\s+/g,'-')}`}>
              <h2 className="font-display text-2xl font-bold">{g.group}</h2>
              <Accordion type="single" collapsible className="mt-4">
                {g.items.map((f, i) => (
                  <AccordionItem value={`${gi}-${i}`} key={i} data-testid={`faq-item-${gi}-${i}`}>
                    <AccordionTrigger className="text-left text-base font-semibold">{f.q}</AccordionTrigger>
                    <AccordionContent className="text-slate-700 text-sm leading-relaxed">{f.a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
